export enum EAuthActions {
    SET_HAS_ACCESS = "SET_HAS_ACCESS"
} 

export interface ISetHasAccess {
    type: EAuthActions.SET_HAS_ACCESS,
    payload: boolean; 
}